globalThis.ElementQueries = (function(){
    ElementQueries.mainClass = 'el-query';

    function ElementQueries() { }

    ElementQueries.$elements = [];

    jQuery.fn.updateElementQueries = function()
    {
        var $this = this;
        var $elementQueries = $this.find('.el-query').add($this.filter('.el-query'));
        $elementQueries.each(function()
        {
            var $element = $(this);
            var width = $element.width();
            if(width == 0) return;

            $element.removeClass(   'media-query ' +    // Can be used to set a width to elements waiting for element queries to be initialized
                                    'el-query-min-250 el-query-min-500 el-query-min-768 el-query-min-992 el-query-min-1200 ' +
                                    'el-query-max-249 el-query-max-499 el-query-max-767 el-query-max-991 el-query-max-1199');
            if(width >= 0 && width < 250) {
                $element.addClass('el-query-max-249 el-query-max-499 el-query-max-767 el-query-max-991 el-query-max-1199');
            } else if(width >= 250 && width < 500) {
                $element.addClass(
                  'el-query-min-250 el-query-max-499 el-query-max-767 el-query-max-991 el-query-max-1199'
                );
            } else if(width >= 500 && width < 768) {
                $element.addClass(
                  'el-query-min-250 el-query-min-500 el-query-max-767 el-query-max-991 el-query-max-1199'
                );
            } else if(width >= 768 && width < 992) {
                $element.addClass(
                  'el-query-min-250 el-query-min-500 el-query-min-768 el-query-max-991 el-query-max-1199'
                );
            } else if(width >= 992 && width < 1200) {
                $element.addClass(
                  'el-query-min-250 el-query-min-500 el-query-min-768 el-query-min-992 el-query-max-1199'
                );
            } else if(width >= 1200) {
                $element.addClass(
                  'el-query-min-250 el-query-min-500 el-query-min-768 el-query-min-992 el-query-min-1200'
                );
            }
        });
    }

    ElementQueries.refresh = function() {
        ElementQueries.$elements = $('.' + ElementQueries.mainClass);
        $(window).trigger('resize');
    }

    ElementQueries.updateDuringResizing = function($elements, timeout)
    {
        if(timeout) clearTimeout(timeout);
        timeout = setTimeout(function() { $elements.updateElementQueries() }, 100);
    }

    ElementQueries.init = function()
    {
        var timeout = null;
        $(window).resize( function() { ElementQueries.updateDuringResizing(ElementQueries.$elements, timeout) } );

        $('body').on('resize', '.' + ElementQueries.mainClass, function() { ElementQueries.updateDuringResizing($(this), timeout) });
    }

    return ElementQueries;
})();

ImageQueries = (function()
{
    ImageQueries.mainClass = 'img-query';

    function ImageQueries() { }

    ImageQueries.$elements = [];

    jQuery.fn.updateImgQueries = function()
    {
        var $this = this;
        var $imgQueries = $this.find('.img-query').add($this.filter('.img-query'));

        $imgQueries.each(function()
        {
            var $element = $(this);
            var width = $element.width();
            if(width > 0) {
              $element.attr('sizes', width + 'px');
              picturefill({
                reevaluate: true,
                elements: [$element[0]]
              });
            }
        });
    }

    ImageQueries.refresh = function($container) {
        var selector = '.' + ImageQueries.mainClass;

        if($container && $container.length) {
          ImageQueries.$elements = $container.find(selector);
        } else {
          ImageQueries.$elements = $(selector);
        }

        $(window).resize();
    }

    ImageQueries.updateDuringResizing = function($elements, timeout)
    {
        if(timeout) clearTimeout(timeout);
        timeout = setTimeout(function() { if($elements.length) $elements.updateImgQueries() }, 100);
    }

    ImageQueries.init = function()
    {
        var timeout = null;
        $(window).resize( function() { ImageQueries.updateDuringResizing(ImageQueries.$elements, timeout) } );

        $('body').on('resize', '.' + ImageQueries.mainClass, function() { ImageQueries.updateDuringResizing($(this), timeout) });
    }

    return ImageQueries;
})();

window.onload = function() {
  ElementQueries.init();
  ElementQueries.refresh();
}
